const Q = require('q');
const model = require('model/model');
const pubsub = require('events/pubsub');
const classService = require('services/classService');
const _ = require('underscore');

const STATUS_MAP = {
	active: 'a',
	archived: 'r',
	deleted: 'd'
};

const updateClass = (params, options) => {
	return classService.updateClass(params).then(() => {
		if (options.message) {
			pubsub.publish('message-success', options.message);
		}
		if (options.reloadClasses) {
			pubsub.publish('update-classes');
		}

		return true;
	});
};

const loadClasses = () => {
	return classService.getClasses().then(classes => {
		if (classes && classes.length) {
			classes.sort(function (a, b) {
				let nameA = (a.name || '').toLowerCase();
				let nameB = (b.name || '').toLowerCase();
				if (nameA < nameB) {
					return -1;
				} else if (nameA > nameB) {
					return 1;
				} else {
					return 0;
				}
			});
			model.set('classes', [...classes]);
		} else {
			model.set('classes', []);
		}
		return classes;
	});
};

const loadActiveClasses = () => {
	return loadClasses().then(classes => {
		let activeClasses = classes.filter(c => {
			return c.status !== STATUS_MAP.archived;
		});

		model.set('activeClasses', [...activeClasses]);
		return activeClasses;
	});
};

const archiveClass = (clazz, options) => {
	let status = STATUS_MAP.archived;
	let defaultOptions = {
		message: 'Archived class ' + clazz.name,
		reloadClasses: true
	};

	options = options ? _.assign(defaultOptions, options) : defaultOptions;

	return updateClass(
		{
			classCode: clazz.classCode,
			status
		},
		options
	);
};

const unarchiveClass = (clazz, options) => {
	let status = STATUS_MAP.active;
	let defaultOptions = {
		message: 'Unarchived class ' + clazz.name,
		reloadClasses: true
	};

	options = options ? _.assign(defaultOptions, options) : defaultOptions;

	return updateClass(
		{
			classCode: clazz.classCode,
			status
		},
		options
	);
};

const deleteClass = (clazz, options) => {
	let token;
	let status = STATUS_MAP.deleted;
	let defaultOptions = {
		message: 'Deleted class ' + clazz.name,
		reloadClasses: true
	};

	if (clazz.token) {
		token = clazz.token;
	}

	options = options ? _.assign(defaultOptions, options) : defaultOptions;

	return updateClass(
		{
			classCode: clazz.classCode,
			status,
			token
		},
		options
	);
};

const getBigBookOfKnowledge = (d, ed) => {
	let userContext = model.get('userContext');
	let uid = model.get('studentId');
	let cc = model.get('classCode');
	let params = {
		d,
		ed
	};

	if (!userContext) {
		return Q.reject();
	}

	if (!userContext.classCode) {
		_.assign(params, {
			uid,
			cc
		});
	}

	return classService.getBigBookOfKnowledge(params).then(bigBok => {
		model.set('bigBok', bigBok);
	});
};

const sortStudentsByName = (a, b) => {
	a.firstName = a.firstName.trim();
	const firstNameA = a.firstName.toUpperCase();
	if (a.lastName) {
		a.lastName = a.lastName.trim();
	}
	const lastNameA = (a.lastName || '').toUpperCase();

	b.firstName = b.firstName.trim();
	const firstNameB = b.firstName.toUpperCase();
	if (b.lastName) {
		b.lastName = b.lastName.trim();
	}
	const lastNameB = (b.lastName || '').toUpperCase();

	const nameA = lastNameA + ' ' + firstNameA;
	const nameB = lastNameB + ' ' + firstNameB;

	if ((lastNameA && lastNameB) || (!lastNameA && !lastNameB)) {
		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}
	} else {
		if (!lastNameB) {
			return -1;
		}
		if (!lastNameA) {
			return 1;
		}
	}
	return 0;
};

const fetchRoster = classCode => {
	if (!classCode) {
		return Q(false);
	}

	let allRosters = model.get('roster') || {};
	delete allRosters[classCode];
	model.set('roster', _.assign({}, allRosters));

	return classService
		.getClassRoster({
			classCode
		})
		.then(roster => {
			let studentsById = {};

			roster.students.forEach(function (student) {
				studentsById[student.uid] = student;
			});
			roster.studentsById = studentsById;

			// Update class roster in model
			let persistedRoster = model.get('roster') || {};
			// TODO: Default values in model
			persistedRoster = _.assign({}, persistedRoster, {
				[classCode]: roster
			});
			model.set('roster', persistedRoster);

			return roster;
		});
};

module.exports = {
	STATUS_MAP,
	sortStudentsByName,
	loadClasses,
	loadActiveClasses,
	archiveClass,
	unarchiveClass,
	deleteClass,
	updateClass,
	getBigBookOfKnowledge,
	fetchRoster
};
